// JANM shell interactions
(function () {
  "use strict";
  // 语言下拉（视觉复刻：开合菜单）
  document.querySelectorAll(".v2-language-trigger").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = btn.getAttribute("aria-expanded") === "true";
      document.querySelectorAll(".v2-language-trigger").forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
      });
      btn.setAttribute("aria-expanded", open ? "false" : "true");
    });
  });
  document.addEventListener("click", function () {
    document.querySelectorAll(".v2-language-trigger").forEach(function (b) {
      b.setAttribute("aria-expanded", "false");
    });
  });
  // 头部询盘按钮 -> 打开 merge-inquiry 抽屉
  var bagBtn = document.querySelector(".v2-bag-button");
  if (bagBtn && window.__liOpenBag) {
    bagBtn.addEventListener("click", function () { window.__liOpenBag(); });
  }
  // 日常仪式选项卡
  var ritualTabs = document.querySelectorAll('.v2-choice-grid button[role="tab"]');
  ritualTabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      ritualTabs.forEach(function (t) { t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
      var panel = document.getElementById("ritual-panel");
      var map = window.__janmRitualPanels;
      if (panel && map && map[tab.id]) {
        var d = map[tab.id];
        var h2 = panel.closest(".v2-editorial-copy").querySelector("h2");
        if (h2 && d.title) h2.textContent = d.title;
        if (d.panel) panel.textContent = d.panel;
      }
    });
  });
})();
